// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__l_dym","content":"Banner_content__Y0Pwh","error":"Banner_error__r7wku"};